import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export const ALLOWED_DOMAIN = 'chicagoventure.com';
// On the allowed domain but no access to this tool; has Beacon only. Lowercase.
const DENIED_EMAILS = ['slynch@chicagoventure.com'];

export function emailAllowed(email) {
  const e = (email ?? '').toLowerCase();
  return e.endsWith(`@${ALLOWED_DOMAIN}`) && !DENIED_EMAILS.includes(e);
}

const googleProvider = new GoogleAuthProvider();
// `hd` asks Google to pre-filter the account chooser to the workspace domain. It's a
// convenience, not a control — the domain check below hides the UI, and the server's
// token verification is what actually enforces access.
googleProvider.setCustomParameters({ hd: ALLOWED_DOMAIN, prompt: 'select_account' });

/**
 * Sign in with Google. Throws if the account isn't allowed (wrong domain or denied).
 */
export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider);
  const email = result.user.email ?? '';

  if (!emailAllowed(email)) {
    await signOut(auth);
    throw new Error(
      `Access restricted to @${ALLOWED_DOMAIN} accounts. You signed in with ${email}.`
    );
  }

  return result.user;
}

export async function signOutUser() {
  await signOut(auth);
}
